import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useProducts } from '../../hooks/useProducts';
import { useSettings } from '../../store/settingsStore';
import { productPath } from '../../lib/productPath';
import { formatPrice } from '../../lib/utils';

export default function DealsBanner() {
  const { bannerProducts, loadProducts } = useProducts();
  const { dealsMarqueeEnabled } = useSettings();

  useEffect(() => {
    void loadProducts();
  }, [loadProducts]);

  const products = [...bannerProducts]
    .sort((a, b) => (a.bannerOrder ?? 999) - (b.bannerOrder ?? 999) || a.name.localeCompare(b.name))
    .slice(0, 8);

  if (!dealsMarqueeEnabled || products.length === 0) return null;

  const renderItem = (product: (typeof products)[number], copy: string) => (
    <Link key={`${product.id}-${copy}`} to={productPath(product)} className="deals-banner-item">
      <span>{product.name}</span>
      <span className="deal-price">{formatPrice(product.price)}</span>
      <span className="deal-sep">|</span>
    </Link>
  );

  return (
    <div className="deals-banner deals-banner-slow deals-banner-products" role="marquee" aria-label="Ofertas destacadas">
      <div className="deals-banner-track" style={{ animationDuration: '120s' }}>
        {[0, 1, 2, 3].flatMap((copy) => products.map((product) => renderItem(product, String(copy))))}
      </div>
    </div>
  );
}
